function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M236.4,414.2v-40.4c-23.2-0.4-47.2-7.6-61.2-17.6l9.6-26.8c14.4,9.6,35.2,17.2,57.6,17.2c28.4,0,47.6-16.4,47.6-39.2 c0-22-15.6-35.6-45.2-47.6c-40.8-16-66-34.4-66-69.2c0-33.2,23.6-58.4,60.4-64.4V85.8H264v38.8c24,0.8,40.4,7.2,52,14L306,165 c-8.4-4.8-24.8-13.6-50.4-13.6c-30.8,0-42.4,18.4-42.4,34.4c0,20.8,14.8,31.2,49.6,45.6c41.2,16.8,62,37.6,62,73.2 c0,31.6-22,61.2-63.2,68v41.6H236.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7,263.9c0-9.3,0-18.6,0-27.9c0.3-1.3,0.7-2.7,0.8-4c2.3-33.2,11.1-64.7,27.1-93.8C76.6,71,132.9,30,208.3,15.6 c9.1-1.7,18.4-2.5,27.5-3.8c9.3,0,18.6,0,27.9,0c3.4,0.4,6.7,0.8,10.1,1.1c50.2,5.5,94.6,24.7,132.8,57.8 c74.8,64.8,102.6,173.5,65,265C433.1,429.2,361.8,479.9,261,487.6c-39.1,3-77-4.8-112.2-22.1C75.6,429.6,31,371.5,15.4,291.4 C13.7,282.3,12.9,273,11.7,263.9z M249.9,426.6c97.4-0.2,176.6-79.5,176.6-176.7c0-97.2-79.2-176.5-176.6-176.7 C152.7,73,72.6,153.2,73.1,250.1C73.5,347.6,152.9,426.9,249.9,426.6z"
});

var SvgCaja = function SvgCaja(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaja, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caja.d9555a84.svg";
export { ForwardRef as ReactComponent };